import { useState } from "react";
import { Link } from "react-router-dom";
import PopupLightbox from "../components/PopupLightbox";

import imgCloseIcon from "../images/icon-close.png";
import imgBrianV from "../images/bio/brian-v.jpg";

const Retirements = () => {
  const [popup1, setPopup1] = useState(false);

  return (
    <div className="grid-container dark-bg">
      <div className="popup-wrapper">
        <div className="popup-col colA">
          <div className="popup-col-inner">
            <h2>Retirements</h2>
            <Link className="close-btn" to="/">
              <img src={imgCloseIcon} alt="close button" />
            </Link>

            <ul className="circle-container">
              <li>
                <Link
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${imgBrianV})` }}
                  onClick={() => setPopup1(true)}
                >
                  <span>Brian Voigt </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <PopupLightbox
        trigger={popup1}
        setTrigger={setPopup1}
        columnPosition="colB"
        slugCategory={"emeriti"}
        slug={"brian-voigt"}
      >
        <h3>Brian Voigt</h3>
        <p>
          <strong>A Fond Farewell</strong>
        </p>

        <p>
          From the glittering city of New York to the vibrant bustle of Hong Kong, Brian Voigt, (MAcc 1983), thrived in
          a multifarious career in tax and global resources. Little did he know that his global journey would eventually
          lead him back to the quiet familiarity of Provo.
        </p>
        <p>
          This unexpected chapter began on an ordinary afternoon in 2016. While visiting a friend, Voigt came across a
          job opening at BYU Marriott’s School of Accountancy (SOA). A proud SOA alumnus, Voigt was immediately drawn to
          the opportunity to return to his alma mater. After consulting with his business partner and his wife, he
          applied for the position. That summer, Voigt officially became the SOA career director and a member of the BYU
          Marriot family.
        </p>
        <p>
          During his time as the SOA career director, Voigt served hundreds of students and initiated several changes to
          enhance career services. Driven by a desire to maximize student success, he introduced the Week Zero program
          to jumpstart the SOA recruiting process before school began. Voigt also spearheaded initiatives like the
          NetTrek program, which gave students exposure to companies across the United States and played a key role in
          creating the SOA career website, ensuring students had access to tailored resources. His efforts also led to
          increased opportunities and pathways into management consulting, real estate, investment banking, and
          advisory.
        </p>
        <p>
          After eight years, Voigt decided it was finally time to embark on the next chapter of his life: retirement.
          Looking ahead, he is eager to indulge in new adventures, like serving missions with his wife, traveling the
          world, or spending quality time with his family.
        </p>
        <p>
          As he bids farewell to the students, faculty, and alumni of the SOA, Voigt reflects fondly on the impact they
          made on his life. “Thank you for the opportunity to serve with you, to be with you, to learn with you, to be
          lifted by your light, your hope, your goodness, and your intellect,” Voigt shares. “The SOA family has been a
          great blessing in my life. Being here has truly been the pinnacle of my career.”
        </p>
      </PopupLightbox>
    </div>
  );
};

export default Retirements;
